import { useState } from "react";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "@babackapp/ui/components/button";
import useTranslation from "@babackapp/translations/use-translation";

interface ResendFormProps {
  onSubmit: (email: string) => Promise<void>;
  onCancel: () => void;
  isLoading: boolean;
}

export function ResendForm({ onSubmit, onCancel, isLoading }: ResendFormProps) {
  const t = useTranslation();
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    await onSubmit(email.trim());
  };

  const handleCancel = () => {
    setEmail("");
    onCancel();
  };

  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-6">
        <XCircleIcon className="h-8 w-8 text-blue-600" aria-hidden="true" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {t("verifyEmail.error.resend")}
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        Enter your email address to receive a new verification link.
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="sr-only">
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
            required
            disabled={isLoading}
          />
        </div>
        <div className="space-y-3">
          <Button
            type="submit"
            className="w-full"
            disabled={isLoading || !email.trim()}
          >
            {isLoading ? "Sending..." : "Send verification email"}
          </Button>
          <Button
            type="button"
            onClick={handleCancel}
            variant="outline"
            className="w-full"
            disabled={isLoading}
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
}